<template>
	<label class="hint-wrapper">{{ getLabel }}
		<img
			:src="require(`@/common/assets/icons/help-yellow.svg`)"
			alt="hint"
		/>
		<div class="hint-container">
			<slot name="hint"/>
		</div>
	</label>
</template>

<script>
export default {
	name: "CommonHint",
	props: {
		hint: {
			type: Boolean,
			required: false
		},
		label: {
			type: String,
			required: false
		},
	},
	computed: {
		getLabel() {
			return this.label ? this.label : ''
		}
	},
	data() {
		return {
			displayHint: false
		}
	}
}
</script>

<style lang="scss" scoped>
	.hint-wrapper {
		position: relative;
	}

	.hint-wrapper > span {
		margin-left: 15px;
	}

	.hint-container{
		border-radius: 5px;
		padding: 10px;
		position: absolute;
		display: none;
		font-size: 14px;

		::after {
			content: '';
			position: absolute;
			top: 100%;
			left: 35px;
			margin-left: -10px;
			border-width: 8px;
			border-style: solid;
			border-color: white transparent transparent transparent;
		}
	}

	.hint-wrapper:hover .hint-container{
		width: 300px;
		left: -20px;
		bottom: 30px;
		z-index: 10;
		display: block;
		background: white;
		color: black;
	}
</style>
